import { Chip as BaseChip, styled } from "@mui/material";

const Chip = styled(BaseChip)(({ theme }) => ({
  minWidth: 20,
  width: 20,
  height: 20,
  fontSize: theme.typography.pxToRem(12),
  fontWeight: theme.typography.fontWeightBold,
  "& .MuiChip-label": {
    padding: 0,
  },
}));

export { Chip };
